commusoftCommon.filter('dateShortFormat', function(CS_LANGUAGE) {
    return function(dateString) {
        if(dateString == ''){
            return '';
        }
        moment.locale(CS_LANGUAGE);
        return moment.utc(dateString).zone(moment().format('Z')).format('ddd Do MMM YYYY');
    };
});